<h2 mat-dialog-title>Create New Event</h2>

<div mat-dialog-content>
  <form #f="ngForm">
    <div class="form-container">
      <!-- Group Selection -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Group</mat-label>
        <mat-select name="group_id" [(ngModel)]="model.group_id" required>
          <mat-option *ngFor="let group of adminGroups" [value]="group.group_id">
            {{ group.group_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Event Name -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Event Name</mat-label>
        <input matInput name="name" [(ngModel)]="model.name" required />
      </mat-form-field>

      <!-- Event Date -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Event Date</mat-label>
        <input matInput type="date" name="event_date" [(ngModel)]="model.event_date" required />
      </mat-form-field>

      <!-- Event Type -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Event Type</mat-label>
        <mat-select name="event_type" [(ngModel)]="model.event_type" [disabled]="loadingEventTypes" required>
          <mat-option *ngFor="let type of eventTypes" [value]="type.type_id">
            {{ type.type_text }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Description -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea matInput name="description" rows="4" [(ngModel)]="model.description"></textarea>
      </mat-form-field>

      <!-- Is Private -->
      <mat-checkbox name="is_private" [(ngModel)]="isPrivateChecked">
        Private Event
      </mat-checkbox>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="saving">Cancel</button>
  <button 
    mat-raised-button 
    color="primary" 
    (click)="onSubmit()" 
    [disabled]="!canSubmit() || saving">
    <mat-spinner *ngIf="saving" diameter="18" mode="indeterminate" style="display: inline-block; margin-right: 8px;"></mat-spinner>
    Create Event
  </button>
</div>
